import { render, staticRenderFns } from "./PageTenants.vue?vue&type=template&id=30e15f3e&"
import script from "./PageTenants.vue?vue&type=script&lang=ts&"
export * from "./PageTenants.vue?vue&type=script&lang=ts&"
import style0 from "./PageTenants.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
installComponents(component, {VSpacer,VTab})
